import { Fragment } from "react";
import { Link, type LinkProps } from "react-router-dom";
import classnames from "classnames";

import style from "./style.module.scss";
import logo from "../../../assets/lymabook-64-copy.png";

interface LogoProps extends Omit<LinkProps, "to"> {
  small?: boolean;
  withShadow?: boolean;
}

function Logo({ small = false, withShadow = false, ...props }: LogoProps) {
  return (
    <Link
      className={classnames(style.logo, {
        [style.withShadow]: withShadow,
      })}
      to="/"
      {...props}
    >
      <img
        className={style.image}
        src={logo}
        alt="Lymaprint : Mon livre ou calendrier photo livré partout en Algérie"
      />
      {!small && (
        <Fragment>
          <span className={style.part1}>lyma</span>
          <span className={style.part2}>print</span>
        </Fragment>
      )}
    </Link>
  );
}

export default Logo;
